export const getUploadSign = async (platform: number) => {
    const obj = {
        url: RequestAPI.GET_FILE_UPLOAD_SIGN,
        query: {
            platform: platform
        }
    }
    const { data } = await getRequired(obj);
    if (data && data.value.code === 2000) {
        console.log(data.value)
    }
    return data.value
}

export const getAliOssToken = async () => { // 获取阿里云OSS上传token
    const obj = {
        url: RequestAPI.GET_ALI_OSS_TOKEN,
        query: {
            platform: 1
        }
    }
    const { data } = await getRequired(obj);
    if (data && data.value.code === 2000) {
        console.log(data.value)
    }
    return data.value
}
